import React, { ReactNode, useMemo } from "react";
import { Button } from "reactstrap";

import { Actions, AuthState, State } from "../types";
import { Authenticated } from "./Authenticated";
import { NotAuthenticated } from "./NotAuthenticated";

import "./styles.scss";

type Props = Readonly<{
  actions: Actions;
  blockingStep: string;
  customSettings: ReactNode | null;
  docs?: React.ReactElement;
  state: State;
}>;

export const Sidebar = ({ actions, blockingStep, customSettings, docs, state }: Props) => {
  const { auth, sidebarVisible } = state;
  const visible =
    sidebarVisible ||
    auth.state === AuthState.notLoggedIn ||
    auth.state === AuthState.loggingInByForm;
  const [shadeClassName, sidebarClassName] = useMemo(() => {
    if (visible) {
      return ["sidebar-shade visible", "sidebar visible"];
    }
    return ["sidebar-shade", "sidebar"];
  }, [visible]);
  let contents;
  let closeButton;
  if (auth.state === AuthState.loggedIn) {
    contents = (
      <Authenticated
        actions={actions}
        auth={auth}
        blockingStep={blockingStep}
        customSettings={customSettings}
        docs={docs}
        jobs={state.jobs}
        jobState={state.job}
      />
    );
    closeButton = (
      <Button close onClick={actions.closeSidebar}>
        <span aria-hidden>&times;</span>
      </Button>
    );
  } else {
    contents = <NotAuthenticated actions={actions} auth={state.auth} />;
  }
  return (
    <>
      <div className={shadeClassName} onClick={actions.closeSidebar} />
      <div className={sidebarClassName}>
        {contents}
        {closeButton}
      </div>
    </>
  );
};
Sidebar.displayName = "Sidebar";
